import config from 'devextreme/core/config';
import { licenseKey } from './devextreme-license';

/*
    Teóricamente cada desarrollador tiene que tener su propia licencia de devextreme. Para aplicarla aquí
    habría que crear un archivo devextreme-license.ts en este mismo directorio que la exportara y que no se subiera al repositorio (metido en gitignore).
    Posteriormente hay que descomentar el import de arriba.
    
    Cada desarrollador al clonarse el proyecto tendría que crear su propio devextreme-license.ts con su licencia. Esto es necesario desde la versión
    23.2 de devextreme. Si no se indica la licencia, la aplicación funcionará correctamente pero aparecerán mensajes de warning en la consola.

    La documentación está aquí: https://js.devexpress.com/Vue/Documentation/Guide/Common/Licensing/#How_to_Obtain_and_Validate_Your_License_Key

 */

export function configure() {
    config({
        licenseKey: licenseKey //se debería usar el licenseKey importado de devextreme-license.ts
    })    
}
